import { render, staticRenderFns } from "./terms_conditions_component.vue?vue&type=template&id=aa8db51c&scoped=true"
import script from "./terms_conditions_component.vue?vue&type=script&lang=js"
export * from "./terms_conditions_component.vue?vue&type=script&lang=js"
import style0 from "./terms_conditions_component.vue?vue&type=style&index=0&id=aa8db51c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8db51c",
  null
  
)

export default component.exports